module.exports = __webpack_public_path__ + "img/safe_tool_6.ea8a77c4.jpg";